<template>
  <div class = "popBoxCommon" v-show = "sh">
    <div class = "p_box">
      <p>{{txt != '' ? txt : ''}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'noneBox',
  props:['txt', 'time'],
  data () {
    return {
      times: 2000,
      sh:false,
    }
  },
  methods: {
    demo_fun () {

    },
    show(){
      this.sh = true;
      if(this.time != undefined){
          this.times = this.time;
      }
      setTimeout(this.hide,this.times);
    },
    hide(){
      this.sh = false;
    }
  },
  created(){
    
  }
}
</script>

<style scoped>
.popBoxCommon{position:fixed;top:0;left:0;right:0;bottom:0;z-index:1000;background:rgba(0,0,0,0.5)}
.popBoxCommon .p_box{text-align:center;width:640px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);}
.popBoxCommon .p_box p{display:inline-block;padding:30px 40px;font-size:32px;color:#6371ea;font-weight:bolder;line-height:36px;background:rgba(255,255,255,0.8);border-radius:200px;text-align:left}
</style>



// WEBPACK FOOTER //
// src/components/common/Alert.vue